import { Component, OnInit } from '@angular/core';
import {NgbActiveModal, NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {CommonModule} from "@angular/common";

@Component({
    selector: 'app-terms-and-conditions',
    templateUrl: './terms-and-conditions.component.html',
    imports: [
        CommonModule,
        NgbModule
    ]
})
export class TermsAndConditionsComponent implements OnInit {

  constructor(public _modal: NgbActiveModal) { }
  public _pageScrollY: number = 0;

  ngOnInit() {
  }

  ngAfterViewInit() {
    
  }

  ngOnDestroy() {
    
  }

  close() {
    this._modal.close();
  }
}
